import type { UserTraits } from '@blueshift-ui/analytics/dist/types/user-traits';

import { useEffect, useRef } from 'react';
import getUserTraits from './helpers/get-user-traits';
import isEqual from 'lodash/isEqual';
import useAnalytics from '@blueshift-ui/analytics/dist/hooks/use-analytics';

interface UseAnalyticsIdentifyParams {
  labUser: any;
}

function useAnalyticsIdentify({ labUser }: UseAnalyticsIdentifyParams) {
  const analytics = useAnalytics();
  const cachedUserTraits = useRef<UserTraits | null>(null);

  useEffect(() => {
    const userTraits = getUserTraits(labUser) ?? null;

    if (!userTraits?.user_id || isEqual(userTraits, cachedUserTraits.current)) {
      return;
    }

    cachedUserTraits.current = userTraits;

    analytics.identify(userTraits.user_id, userTraits);
  }, [analytics, labUser]);
}

export default useAnalyticsIdentify;
